import { render, staticRenderFns } from "./AdminStaffs.vue?vue&type=template&id=695f063d&scoped=true&"
import script from "./AdminStaffs.vue?vue&type=script&lang=js&"
export * from "./AdminStaffs.vue?vue&type=script&lang=js&"
import style0 from "./AdminStaffs.vue?vue&type=style&index=0&id=695f063d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f063d",
  null
  
)

export default component.exports